import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from './Button';

function ContactCTABlock() {
  const navigate = useNavigate();

  return (
    <section className="contact-cta">
      <div className="contact-cta-content">
        <h2>Ready to Contact Us?</h2>
        <p>
          Have questions or need legal guidance? Our experienced team is here to help.
          Get in touch for a free consultation.
        </p>
        <div className="cta-buttons">
          <Button variant="primary" onClick={() => navigate('/qualify')}>
            Contact Us Today
          </Button>
        </div>
      </div>
    </section>
  );
}

export default ContactCTABlock;
